import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'How to access the Aave Polygon Market',
  description:
    'Aave Polygon Market is the Aave Protocol market on Polygon Network (L2). Here you have access to similar assets as in the main Aave Market, but with lower transaction costs as you are using a L2 network.',
  steps: 'Adding Polygon Mainnet is easy, please follow these steps',
});
